module.exports = __webpack_public_path__ + "assets/images/passengers_phase1.5ccd3c15d771bf93934b13e2e1b75614.svg";